import { render, staticRenderFns } from "./SendMessage.vue?vue&type=template&id=32e0cf49";
import script from "./SendMessage.vue?vue&type=script&lang=js";
export * from "./SendMessage.vue?vue&type=script&lang=js";
import style0 from "./SendMessage.vue?vue&type=style&index=0&id=32e0cf49&prod&lang=less";

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;